import { map, filter } from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { findSiteMap, siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withPageReady } from '@bingads-webui-react/with-page-ready';

import { getStyle } from './style';

const PreexecuteContainer = ({
  classes,
  pageName,
  PreexecuteComponents,
  siteMap,
  appPerfMarker,
  ...componentProps
}) => {
  const availableComponents = filter(PreexecuteComponents, (component) => {
    const page = findSiteMap(siteMap, item => item.id === component.pageName);
    return page && page.available;
  });

  if (availableComponents.length === 0) {
    return null;
  }

  const PagePreexecute = withPageReady(
    (ready) => {
      if (ready) {
        const preexecutePerfMarker = appPerfMarker.createChild(`Page_Preexecute_By_${pageName
          || window.location.pathname.split('/').pop()}`, { autoEnd: false });
        preexecutePerfMarker.willInit();

        let count = availableComponents.length;
        let prevPageName = pageName;

        return (
          <div className={classes.preexecuteContainer}>
            {
              map(availableComponents, (NextComponent) => {
                const Preexecution = withPageReady(
                  () => {
                    count -= 1;
                    if (count === 0) {
                      preexecutePerfMarker.done();
                    }
                    return null;
                  },
                  withPageReady(
                    (pageReady) => {
                      if (pageReady) {
                        const childPerfMarker = preexecutePerfMarker.createChild(`Page_Preexecute_${NextComponent.pageName}`, { autoEnd: true });
                        return (
                          <React.Suspense fallback={null}>
                            <NextComponent {...componentProps} perfMarker={childPerfMarker} preexecuteFlag />
                          </React.Suspense>
                        );
                      }
                      return null;
                    },
                    null,
                    prevPageName
                  ),
                  NextComponent.pageName
                );
                prevPageName = NextComponent.pageName;
                return <Preexecution preexecuteFlag {...componentProps} key={`preexecution-${NextComponent.pageName}`} />;
              })
            }
          </div>
        );
      }
      return null;
    },
    null,
    pageName
  );

  return <PagePreexecute />;
};

PreexecuteContainer.propTypes = {
  classes: PropTypes.shape({
    preexecuteContainer: PropTypes.string.isRequired,
  }).isRequired,
  pageName: PropTypes.string.isRequired,
  PreexecuteComponents: PropTypes.arrayOf(PropTypes.elementType).isRequired,
  siteMap: siteMapPropType.isRequired,
  appPerfMarker: perfMarkerPropTypes.isRequired,
};

export const StyledPreexecuteContainer = withDefaultStyles(PreexecuteContainer, getStyle);
